import React, { useState } from "react";
import { clients } from "../data/content";
export function LogoMarquee() {
  return <section className="border-y border-quiet py-12 md:py-14" aria-labelledby="trusted-heading" data-id="element-173" data-mp="2dwso717ja1na">
      <p id="trusted-heading" className="container-x mb-8 font-mono text-[12px] tracking-[0.12em] text-foot" data-id="element-174" data-mp="2iwfcq6stb4be">
        FROM THE STUDIO TRUSTED BY TEAMS AT
      </p>
      <div className="relative overflow-hidden" style={{
      maskImage: "linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)"
    }} data-id="element-175" data-mp="2mvxni9qx5z0i">
        <div className="marquee flex w-max" data-id="element-176" data-mp="2wveowez51qqo">
          {[0, 1].map(copy => <ul key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1} data-id="element-177" data-mp="31mn0nhnxxo70">
              {clients.map(client => <li key={`${copy}-${client.name}`} className="flex h-10 items-center px-8 md:px-12" data-id="element-178" data-mp="36lq5b100dseg">
                  <ClientMark name={client.name} logo={client.logo} data-id="element-179" data-mp="3apfthpcru7yy" />
                </li>)}
            </ul>)}
        </div>
      </div>
    </section>;
}
function ClientMark({
  name,
  logo
}: {
  name: string;
  logo: string;
}) {
  const [failed, setFailed] = useState(false);
  if (logo && !failed) {
    return <img src={logo} alt={name} loading="lazy" onError={() => setFailed(true)} className="h-6 w-auto max-w-[140px] object-contain opacity-60 md:h-7"
    // Force any colour logo to a flat white mark.
    style={{
      filter: "brightness(0) invert(1)"
    }} data-id="element-180" data-mp="3pbnvf77ch1ip" />;
  }
  return <span className="whitespace-nowrap font-sans text-[20px] font-semibold tracking-[-0.02em] text-white/55 md:text-[22px]" data-id="element-181" data-mp="gvcah8g765in">{name}</span>;
}